// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"21":"e92c7ed6","241":"574f26a8","273":"9e27c393","444":"828516c6"}[chunkId] + ".css";
};